import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setAuthToken } from "./api";

const useAuthSync = () => {
  const token = useSelector((s) => s.token);
  useEffect(() => {
    setAuthToken(token);
  }, [token]);
};

export default useAuthSync;
